import React, { useState } from "react";
import { useSelector } from "react-redux";

import Autocomplete from "components/Autocomplete";
import { FormInput } from "components/Form/Form";
import NavButtons from "components/NavButtons/NavButtons";
import { DISABLE_ERRORS } from "utils/constants";
import "../onboarding.css";

const MultipleInputTemplate = ({
    inputHeader,
    inputKey,
    handleNavClick,
    addText,
    placeholder,
    input_limit,
    subheaderText = null,
    autocomplete = false,
    min_blanks,
}) => {
    const settings = useSelector((state) => state.settings);

    const [inputValue, setInputValue] = useState(
        settings[inputKey].length < min_blanks
            ? [...settings[inputKey], ...Array(min_blanks - settings[inputKey].length).fill("")]
            : settings[inputKey]
    );
    const [errorMsg, setErrorMsg] = useState("");
    const [currentFocus, setCurrentFocus] = useState(0);

    const update_current_focus = (index) => {
        setCurrentFocus(index);
    };

    const update_input_value = (value, index) => {
        setInputValue((prev) => {
            prev[index] = value;
            return [...prev];
        });
    };

    const next_clicked = (action) => {
        setErrorMsg(false);
        let hasError = false;
        // validate input
        if (action === "next") {
            if (inputValue.length === 0 || inputValue.every((val) => val === "")) {
                setErrorMsg("Please enter at least 1 value");
                hasError = true;
            }
        }

        if (hasError && !DISABLE_ERRORS) return;
        let response_obj = [
            {
                key: inputKey,
                value: inputValue.filter((item) => item !== "" && item !== null),
            },
        ];
        console.log(response_obj);
        handleNavClick(action, response_obj, "array");
    };

    const addExtraField = () => {
        setErrorMsg(false);
        if (inputValue.length < input_limit) {
            setInputValue([...inputValue, ""]);
        }
    };

    return (
        <>
            <div className="form-container">
                <div className="input-header">
                    <div className="input-header-text">
                        <p>{inputHeader}</p>
                    </div>
                </div>
                {subheaderText && (
                    <div className="subheader margin-y-low centered fit-to-width">
                        <div className="subheader-text">
                            <p>{subheaderText}</p>
                        </div>
                    </div>
                )}
                {inputValue.map((value, index) => {
                    return (
                        <div className="centered" key={index}>
                            <div className={`input-bar centered ${autocomplete ? "autocomplete_wrapper" : ""}`}>
                                {autocomplete ? (
                                    <Autocomplete
                                        key={index}
                                        inputKey={inputKey}
                                        inputValue={value}
                                        handleEnterKey={null}
                                        inputIndex={index}
                                        setInputValue={update_input_value}
                                        setCurrentFocus={update_current_focus}
                                        isFocused={currentFocus === index}
                                        placeholder={placeholder}
                                    />
                                ) : (
                                    <FormInput
                                        type="text"
                                        inputValue={inputValue[index]}
                                        inputName={inputKey}
                                        placeholder={placeholder}
                                        onChange={(value) => update_input_value(value, index)}
                                    />
                                )}
                            </div>
                        </div>
                    );
                })}

                {inputValue.length < input_limit && (
                    <div className="add-custom-option">
                        <p className="add-custom-option-text link" onClick={() => addExtraField()}>
                            {addText}
                        </p>
                    </div>
                )}

                <div className="input-error-msg">{errorMsg && <div className="error-msg">{errorMsg}</div>}</div>
            </div>
            <NavButtons handleNavClick={next_clicked} />
        </>
    );
};

export default MultipleInputTemplate;
